import type BrandSubscriptionModel from '../store/schema/BrandSubscriptionModel';
import type BrandSubscriptionStore from './schema/BrandSubscriptionStore';
import { createStore } from 'owa-satcheljs';

const getBrandSubscriptionStore: () => BrandSubscriptionStore = createStore<BrandSubscriptionStore>(
    'BrandSubscription',
    {
        subscriptions: new Map<string, BrandSubscriptionModel>([]),
        unsubscribedSubscriptions: new Map<string, BrandSubscriptionModel>([]),
    }
);

export default getBrandSubscriptionStore;
